import React from 'react';
import { Typography } from 'antd';
import { theme } from '../../theme';
import { StatCardsContainer } from './StatCard';

const { Title } = Typography;

export interface StatSectionProps {
  /** Título de la sección */
  title: string;
  /** Color del header de la sección */
  headerColor?: string;
  /** Color de fondo del header (opcional) */
  headerBgColor?: string;
  /** Icono opcional para el título */
  icon?: React.ReactNode;
  /** Contenido de la sección (tarjetas) */
  children: React.ReactNode;
  /** Espaciado entre tarjetas */
  gap?: number;
  /** Ancho mínimo de columna */
  minColumnWidth?: string;
  /** Estilos adicionales */
  style?: React.CSSProperties;
}

/**
 * Componente contenedor para agrupar tarjetas de estadísticas relacionadas
 * Incluye header con título y color distintivo
 * 
 * @example
 * <StatSection
 *   title="Compras e Ingresos"
 *   headerColor={theme.colors.success}
 *   headerBgColor="#f6ffed"
 * >
 *   <ClickableStatCard ... />
 *   <ClickableStatCard ... />
 * </StatSection>
 */
export const StatSection: React.FC<StatSectionProps> = ({
  title,
  headerColor = theme.colors.primary,
  headerBgColor,
  icon,
  children,
  gap = 16,
  minColumnWidth = '200px',
  style = {}
}) => {
  return (
    <div style={{ marginBottom: '24px', ...style }}>
      {/* Header de la sección */}
      <div
        style={{
          padding: '12px 16px',
          backgroundColor: headerBgColor || 'transparent',
          borderLeft: `4px solid ${headerColor}`,
          borderRadius: '4px',
          marginBottom: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        {icon && (
          <span style={{ fontSize: '18px', display: 'flex', alignItems: 'center' }}>
            {icon}
          </span>
        )}
        <Title
          level={4}
          style={{
            margin: 0,
            fontSize: '18px',
            fontWeight: 600,
            color: headerColor
          }}
        >
          {title}
        </Title>
      </div>

      {/* Contenedor de tarjetas */}
      <StatCardsContainer gap={gap} minColumnWidth={minColumnWidth}>
        {children}
      </StatCardsContainer>
    </div>
  );
};

